export const HelpCenterAnimation = {
  nm: "04",
  h: 281,
  w: 281,
  meta: { g: "LottieFiles Figma v91" },
  layers: [
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [27.31, 27.31],
              t: 0,
            },
            { s: [31.5, 31], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [139.71, 113.16],
              t: 0,
            },
            { s: [139.5, 113], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 15.083],
                      [15.083, 0],
                      [0, -15.083],
                      [-15.083, 0],
                    ],
                    o: [
                      [15.083, 0],
                      [0, -15.083],
                      [-15.083, 0],
                      [0, 15.083],
                      [0, 0],
                    ],
                    v: [
                      [27.311, 54.621],
                      [54.621, 27.311],
                      [27.311, 0],
                      [0, 27.311],
                      [27.311, 54.621],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 17.12],
                      [17.4, 0],
                      [0, -17.12],
                      [-17.4, 0],
                    ],
                    o: [
                      [17.4, 0],
                      [0, -17.12],
                      [-17.4, 0],
                      [0, 17.12],
                      [0, 0],
                    ],
                    v: [
                      [31.5, 62],
                      [63, 31],
                      [31.5, 0],
                      [0, 31],
                      [31.5, 62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "st",
          nm: "",
          lc: 1,
          lj: 2,
          ml: 4,
          o: { a: 0, k: 100 },
          w: {
            a: 1,
            k: [
              { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [2], t: 0 },
              { s: [2], t: 75 },
            ],
          },
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
        },
      ],
      ind: 1,
    },
    {
      ty: 4,
      nm: "Vector (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [19.96, 19.96] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [139.71, 113.16] },
        r: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
            { s: [102.05], t: 75 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.527, 0],
                      [0.517, 0.04],
                      [0, 0],
                      [-0.475, 0],
                      [-0.465, 0.036],
                      [0, 0],
                    ],
                    o: [
                      [-0.517, 0.04],
                      [-0.527, 0],
                      [0, 0],
                      [0.465, 0.036],
                      [0.475, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21.524, 39.855],
                      [19.958, 39.915],
                      [18.392, 39.855],
                      [18.546, 37.861],
                      [19.958, 37.915],
                      [21.369, 37.861],
                      [21.524, 39.855],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.53, 0],
                      [0.52, 0.04],
                      [0, 0],
                      [-0.48, 0],
                      [-0.47, 0.04],
                      [0, 0],
                    ],
                    o: [
                      [-0.52, 0.04],
                      [-0.53, 0],
                      [0, 0],
                      [0.47, 0.04],
                      [0.48, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21.52, 39.85],
                      [19.96, 39.92],
                      [18.39, 39.85],
                      [18.55, 37.86],
                      [19.96, 37.92],
                      [21.37, 37.86],
                      [21.52, 39.85],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.923, -0.221],
                      [0, 0],
                      [0.958, 0.397],
                      [0, 0],
                    ],
                    o: [
                      [0.861, 0.357],
                      [0, 0],
                      [-1.026, -0.246],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.084, 36.554],
                      [15.763, 37.423],
                      [15.298, 39.368],
                      [12.318, 38.4],
                      [13.084, 36.554],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.92, -0.22],
                      [0, 0],
                      [0.96, 0.4],
                      [0, 0],
                    ],
                    o: [
                      [0.86, 0.36],
                      [0, 0],
                      [-1.03, -0.25],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.08, 36.55],
                      [15.76, 37.42],
                      [15.3, 39.37],
                      [12.32, 38.4],
                      [13.08, 36.55],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [1.026, -0.246],
                      [0, 0],
                      [-0.861, 0.357],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.958, 0.397],
                      [0, 0],
                      [0.923, -0.221],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [27.215, 37.477],
                      [27.598, 38.4],
                      [24.618, 39.368],
                      [24.152, 37.423],
                      [26.831, 36.554],
                      [27.215, 37.477],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [1.03, -0.25],
                      [0, 0],
                      [-0.86, 0.36],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.96, 0.4],
                      [0, 0],
                      [0.92, -0.22],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [27.21, 37.48],
                      [27.6, 38.4],
                      [24.62, 39.37],
                      [24.15, 37.42],
                      [26.83, 36.55],
                      [27.21, 37.48],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.804, -0.493],
                      [0, 0],
                      [0, 0],
                      [0.793, 0.678],
                      [0, 0],
                    ],
                    o: [
                      [0.714, 0.61],
                      [0, 0],
                      [0, 0],
                      [-0.893, -0.548],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [8.295, 33.613],
                      [10.574, 35.273],
                      [10.051, 36.124],
                      [9.528, 36.977],
                      [6.996, 35.134],
                      [8.295, 33.613],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.8, -0.49],
                      [0, 0],
                      [0, 0],
                      [0.79, 0.68],
                      [0, 0],
                    ],
                    o: [
                      [0.71, 0.61],
                      [0, 0],
                      [0, 0],
                      [-0.89, -0.55],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [8.29, 33.61],
                      [10.57, 35.27],
                      [10.05, 36.12],
                      [9.53, 36.98],
                      [7, 35.13],
                      [8.29, 33.61],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.893, -0.548],
                      [0, 0],
                      [-0.714, 0.61],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.793, 0.678],
                      [0, 0],
                      [0.804, -0.493],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [32.27, 34.374],
                      [32.92, 35.134],
                      [30.388, 36.977],
                      [29.341, 35.273],
                      [31.62, 33.613],
                      [32.27, 34.374],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.89, -0.55],
                      [0, 0],
                      [-0.71, 0.61],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.79, 0.68],
                      [0, 0],
                      [0.8, -0.49],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [32.27, 34.37],
                      [32.92, 35.13],
                      [30.39, 36.98],
                      [29.34, 35.27],
                      [31.62, 33.61],
                      [32.27, 34.37],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.61, -0.714],
                      [0, 0],
                      [0.548, 0.893],
                      [0, 0],
                    ],
                    o: [
                      [0.493, 0.804],
                      [0, 0],
                      [-0.677, -0.792],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4.644, 29.341],
                      [6.302, 31.62],
                      [4.781, 32.92],
                      [2.939, 30.388],
                      [4.644, 29.341],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.61, -0.71],
                      [0, 0],
                      [0.55, 0.89],
                      [0, 0],
                    ],
                    o: [
                      [0.49, 0.8],
                      [0, 0],
                      [-0.68, -0.79],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4.64, 29.34],
                      [6.3, 31.62],
                      [4.78, 32.92],
                      [2.94, 30.39],
                      [4.64, 29.34],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.678, -0.793],
                      [0, 0],
                      [0, 0],
                      [-0.493, 0.804],
                      [0, 0],
                    ],
                    o: [
                      [-0.548, 0.893],
                      [0, 0],
                      [0, 0],
                      [0.61, -0.714],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [36.977, 30.388],
                      [35.134, 32.92],
                      [34.374, 32.27],
                      [33.613, 31.62],
                      [35.273, 29.341],
                      [36.977, 30.388],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.68, -0.79],
                      [0, 0],
                      [0, 0],
                      [-0.49, 0.8],
                      [0, 0],
                    ],
                    o: [
                      [-0.55, 0.89],
                      [0, 0],
                      [0, 0],
                      [0.61, -0.71],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [36.98, 30.39],
                      [35.13, 32.92],
                      [34.37, 32.27],
                      [33.61, 31.62],
                      [35.27, 29.34],
                      [36.98, 30.39],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.357, -0.861],
                      [0, 0],
                      [0.246, 1.026],
                      [0, 0],
                    ],
                    o: [
                      [0.221, 0.923],
                      [0, 0],
                      [-0.397, -0.958],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.492, 24.152],
                      [3.362, 26.831],
                      [1.515, 27.598],
                      [0.547, 24.618],
                      [2.492, 24.152],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.36, -0.86],
                      [0, 0],
                      [0.25, 1.03],
                      [0, 0],
                    ],
                    o: [
                      [0.22, 0.92],
                      [0, 0],
                      [-0.4, -0.96],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.49, 24.15],
                      [3.36, 26.83],
                      [1.51, 27.6],
                      [0.55, 24.62],
                      [2.49, 24.15],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.397, -0.958],
                      [0, 0],
                      [0, 0],
                      [-0.221, 0.923],
                      [0, 0],
                    ],
                    o: [
                      [-0.246, 1.026],
                      [0, 0],
                      [0, 0],
                      [0.357, -0.861],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [39.368, 24.618],
                      [38.4, 27.598],
                      [37.477, 27.215],
                      [36.554, 26.831],
                      [37.423, 24.152],
                      [39.368, 24.618],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.4, -0.96],
                      [0, 0],
                      [0, 0],
                      [-0.22, 0.92],
                      [0, 0],
                    ],
                    o: [
                      [-0.25, 1.03],
                      [0, 0],
                      [0, 0],
                      [0.36, -0.86],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [39.37, 24.62],
                      [38.4, 27.6],
                      [37.48, 27.21],
                      [36.55, 26.83],
                      [37.42, 24.15],
                      [39.37, 24.62],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.04, 0.517],
                      [0, 0],
                      [0, -0.475],
                      [-0.036, -0.465],
                      [0, 0],
                      [0, 0.527],
                    ],
                    o: [
                      [0, -0.527],
                      [0, 0],
                      [-0.036, 0.465],
                      [0, 0.475],
                      [0, 0],
                      [-0.04, -0.517],
                      [0, 0],
                    ],
                    v: [
                      [0, 19.958],
                      [0.061, 18.392],
                      [2.055, 18.546],
                      [2, 19.958],
                      [2.055, 21.369],
                      [0.061, 21.524],
                      [0, 19.958],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.04, 0.52],
                      [0, 0],
                      [0, -0.48],
                      [-0.04, -0.47],
                      [0, 0],
                      [0, 0.53],
                    ],
                    o: [
                      [0, -0.53],
                      [0, 0],
                      [-0.04, 0.47],
                      [0, 0.48],
                      [0, 0],
                      [-0.04, -0.52],
                      [0, 0],
                    ],
                    v: [
                      [0, 19.96],
                      [0.06, 18.39],
                      [2.05, 18.55],
                      [2, 19.96],
                      [2.05, 21.37],
                      [0.06, 21.52],
                      [0, 19.96],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.036, 0.465],
                      [0, 0],
                      [0, -0.527],
                      [0.04, -0.517],
                      [0, 0],
                      [0, 0.475],
                    ],
                    o: [
                      [0, -0.475],
                      [0, 0],
                      [0.04, 0.517],
                      [0, 0.527],
                      [0, 0],
                      [0.036, -0.465],
                      [0, 0],
                    ],
                    v: [
                      [37.915, 19.958],
                      [37.861, 18.546],
                      [39.855, 18.392],
                      [39.915, 19.958],
                      [39.855, 21.524],
                      [37.861, 21.369],
                      [37.915, 19.958],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.04, 0.47],
                      [0, 0],
                      [0, -0.53],
                      [0.04, -0.52],
                      [0, 0],
                      [0, 0.48],
                    ],
                    o: [
                      [0, -0.48],
                      [0, 0],
                      [0.04, 0.52],
                      [0, 0.53],
                      [0, 0],
                      [0.04, -0.47],
                      [0, 0],
                    ],
                    v: [
                      [37.92, 19.96],
                      [37.86, 18.55],
                      [39.85, 18.39],
                      [39.92, 19.96],
                      [39.85, 21.52],
                      [37.86, 21.37],
                      [37.92, 19.96],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.221, -0.923],
                      [0, 0],
                      [-0.397, 0.958],
                      [0, 0],
                    ],
                    o: [
                      [-0.357, 0.861],
                      [0, 0],
                      [0.246, -1.026],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [3.362, 13.084],
                      [2.492, 15.763],
                      [0.547, 15.298],
                      [1.515, 12.318],
                      [3.362, 13.084],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.22, -0.92],
                      [0, 0],
                      [-0.4, 0.96],
                      [0, 0],
                    ],
                    o: [
                      [-0.36, 0.86],
                      [0, 0],
                      [0.25, -1.03],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [3.36, 13.08],
                      [2.49, 15.76],
                      [0.55, 15.3],
                      [1.51, 12.32],
                      [3.36, 13.08],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.245, -1.026],
                      [0, 0],
                      [0.357, 0.861],
                      [0, 0],
                    ],
                    o: [
                      [0.397, 0.958],
                      [0, 0],
                      [-0.221, -0.923],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [38.4, 12.318],
                      [39.368, 15.298],
                      [37.423, 15.763],
                      [36.554, 13.084],
                      [38.4, 12.318],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.25, -1.03],
                      [0, 0],
                      [0.36, 0.86],
                      [0, 0],
                    ],
                    o: [
                      [0.4, 0.96],
                      [0, 0],
                      [-0.22, -0.92],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [38.4, 12.32],
                      [39.37, 15.3],
                      [37.42, 15.76],
                      [36.55, 13.08],
                      [38.4, 12.32],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.493, -0.803],
                      [0, 0],
                      [-0.677, 0.793],
                      [0, 0],
                    ],
                    o: [
                      [-0.61, 0.714],
                      [0, 0],
                      [0.548, -0.893],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [6.302, 8.295],
                      [4.644, 10.574],
                      [2.939, 9.528],
                      [4.781, 6.996],
                      [6.302, 8.295],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.49, -0.8],
                      [0, 0],
                      [-0.68, 0.79],
                      [0, 0],
                    ],
                    o: [
                      [-0.61, 0.71],
                      [0, 0],
                      [0.55, -0.89],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [6.3, 8.29],
                      [4.64, 10.57],
                      [2.94, 9.53],
                      [4.78, 7],
                      [6.3, 8.29],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.548, -0.893],
                      [0, 0],
                      [0, 0],
                      [0.61, 0.714],
                      [0, 0],
                    ],
                    o: [
                      [0.678, 0.793],
                      [0, 0],
                      [0, 0],
                      [-0.493, -0.804],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [35.134, 6.996],
                      [36.977, 9.528],
                      [36.124, 10.051],
                      [35.273, 10.574],
                      [33.613, 8.295],
                      [35.134, 6.996],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.55, -0.89],
                      [0, 0],
                      [0, 0],
                      [0.61, 0.71],
                      [0, 0],
                    ],
                    o: [
                      [0.68, 0.79],
                      [0, 0],
                      [0, 0],
                      [-0.49, -0.8],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [35.13, 7],
                      [36.98, 9.53],
                      [36.12, 10.05],
                      [35.27, 10.57],
                      [33.61, 8.29],
                      [35.13, 7],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.714, -0.61],
                      [0, 0],
                      [-0.893, 0.548],
                      [0, 0],
                    ],
                    o: [
                      [-0.803, 0.493],
                      [0, 0],
                      [0.793, -0.677],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [10.574, 4.644],
                      [8.295, 6.302],
                      [6.996, 4.781],
                      [9.528, 2.939],
                      [10.574, 4.644],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.71, -0.61],
                      [0, 0],
                      [-0.89, 0.55],
                      [0, 0],
                    ],
                    o: [
                      [-0.8, 0.49],
                      [0, 0],
                      [0.79, -0.68],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [10.57, 4.64],
                      [8.29, 6.3],
                      [7, 4.78],
                      [9.53, 2.94],
                      [10.57, 4.64],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.792, -0.677],
                      [0, 0],
                      [0.804, 0.493],
                      [0, 0],
                    ],
                    o: [
                      [0.893, 0.548],
                      [0, 0],
                      [-0.714, -0.61],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [30.388, 2.939],
                      [32.92, 4.781],
                      [31.62, 6.302],
                      [29.341, 4.644],
                      [30.388, 2.939],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.79, -0.68],
                      [0, 0],
                      [0.8, 0.49],
                      [0, 0],
                    ],
                    o: [
                      [0.89, 0.55],
                      [0, 0],
                      [-0.71, -0.61],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [30.39, 2.94],
                      [32.92, 4.78],
                      [31.62, 6.3],
                      [29.34, 4.64],
                      [30.39, 2.94],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.861, -0.357],
                      [0, 0],
                      [-1.026, 0.246],
                      [0, 0],
                    ],
                    o: [
                      [-0.923, 0.221],
                      [0, 0],
                      [0.958, -0.397],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.763, 2.492],
                      [13.084, 3.362],
                      [12.318, 1.515],
                      [15.298, 0.547],
                      [15.763, 2.492],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.86, -0.36],
                      [0, 0],
                      [-1.03, 0.25],
                      [0, 0],
                    ],
                    o: [
                      [-0.92, 0.22],
                      [0, 0],
                      [0.96, -0.4],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.76, 2.49],
                      [13.08, 3.36],
                      [12.32, 1.51],
                      [15.3, 0.55],
                      [15.76, 2.49],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.958, -0.397],
                      [0, 0],
                      [0.923, 0.221],
                      [0, 0],
                    ],
                    o: [
                      [1.026, 0.246],
                      [0, 0],
                      [-0.861, -0.357],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [24.618, 0.547],
                      [27.598, 1.515],
                      [26.831, 3.362],
                      [24.152, 2.492],
                      [24.618, 0.547],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.96, -0.4],
                      [0, 0],
                      [0.92, 0.22],
                      [0, 0],
                    ],
                    o: [
                      [1.03, 0.25],
                      [0, 0],
                      [-0.86, -0.36],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [24.62, 0.55],
                      [27.6, 1.51],
                      [26.83, 3.36],
                      [24.15, 2.49],
                      [24.62, 0.55],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.517, -0.04],
                      [0, 0],
                      [0.475, 0],
                      [0.465, -0.036],
                      [0, 0],
                      [-0.527, 0],
                    ],
                    o: [
                      [0.527, 0],
                      [0, 0],
                      [-0.465, -0.036],
                      [-0.475, 0],
                      [0, 0],
                      [0.517, -0.04],
                      [0, 0],
                    ],
                    v: [
                      [19.958, 0],
                      [21.524, 0.061],
                      [21.369, 2.055],
                      [19.958, 2],
                      [18.546, 2.055],
                      [18.392, 0.061],
                      [19.958, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.52, -0.04],
                      [0, 0],
                      [0.48, 0],
                      [0.47, -0.04],
                      [0, 0],
                      [-0.53, 0],
                    ],
                    o: [
                      [0.53, 0],
                      [0, 0],
                      [-0.47, -0.04],
                      [-0.48, 0],
                      [0, 0],
                      [0.52, -0.04],
                      [0, 0],
                    ],
                    v: [
                      [19.96, 0],
                      [21.52, 0.06],
                      [21.37, 2.05],
                      [19.96, 2],
                      [18.55, 2.05],
                      [18.39, 0.06],
                      [19.96, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 2,
    },
    {
      ty: 4,
      nm: "Group 2692",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [59.71, 61.36] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [139.71, 113.16] },
        r: {
          a: 1,
          k: [
            { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
            { s: [132.76], t: 75 },
          ],
        },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 3,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [59.71, 61.36] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [59.71, 61.36] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [1.179, 4.331],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [9.056, 2.378],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [6.396, -6.451],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -4.704],
                      [-1.179, -4.331],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-9.056, -2.378],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-6.396, 6.452],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 4.704],
                      [0, 0],
                    ],
                    o: [
                      [0, -4.706],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-6.396, -6.451],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-9.056, 2.377],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-1.179, 4.331],
                      [0, 4.704],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [6.396, 6.452],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [9.056, -2.377],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.179, -4.331],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [111.379, 61.359],
                      [109.568, 47.765],
                      [119.428, 42.072],
                      [106.275, 19.29],
                      [96.404, 24.989],
                      [72.867, 11.387],
                      [72.867, 0],
                      [46.559, 0],
                      [46.559, 11.386],
                      [23.023, 24.987],
                      [13.152, 19.288],
                      [0, 42.071],
                      [9.861, 47.763],
                      [8.049, 61.357],
                      [9.861, 74.951],
                      [0, 80.644],
                      [13.153, 103.426],
                      [23.025, 97.727],
                      [46.561, 111.329],
                      [46.561, 122.715],
                      [72.869, 122.715],
                      [72.869, 111.329],
                      [96.405, 97.727],
                      [106.277, 103.426],
                      [119.43, 80.644],
                      [109.569, 74.951],
                      [111.381, 61.357],
                      [111.379, 61.359],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [1.18, 4.33],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [9.06, 2.38],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [6.4, -6.45],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -4.7],
                      [-1.18, -4.33],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-9.06, -2.38],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-6.4, 6.45],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 4.7],
                      [0, 0],
                    ],
                    o: [
                      [0, -4.71],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-6.4, -6.45],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-9.06, 2.38],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-1.18, 4.33],
                      [0, 4.7],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [6.4, 6.45],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [9.06, -2.38],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.18, -4.33],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [111.38, 61.36],
                      [109.57, 47.77],
                      [119.43, 42.07],
                      [106.28, 19.29],
                      [96.4, 24.99],
                      [72.87, 11.39],
                      [72.87, 0],
                      [46.56, 0],
                      [46.56, 11.39],
                      [23.02, 24.99],
                      [13.15, 19.29],
                      [0, 42.07],
                      [9.86, 47.76],
                      [8.05, 61.36],
                      [9.86, 74.95],
                      [0, 80.64],
                      [13.15, 103.43],
                      [23.02, 97.73],
                      [46.56, 111.33],
                      [46.56, 122.72],
                      [72.87, 122.72],
                      [72.87, 111.33],
                      [96.41, 97.73],
                      [106.28, 103.43],
                      [119.43, 80.64],
                      [109.57, 74.95],
                      [111.38, 61.36],
                      [111.38, 61.36],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "st",
          nm: "",
          lc: 1,
          lj: 2,
          ml: 4,
          o: { a: 0, k: 100 },
          w: {
            a: 1,
            k: [
              { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [2], t: 0 },
              { s: [2], t: 75 },
            ],
          },
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
        },
      ],
      ind: 4,
      parent: 3,
    },
  ],
  v: "5.7.0",
  fr: 60,
  op: 75.01,
  ip: 0,
  assets: [],
};
